module.exports = __webpack_public_path__ + "static/eis8-44d53efc52e0ce82d3c6139b586aad41.jpg";